module.exports = __webpack_public_path__ + "static-m/img/audio.7d2f8202.png";